import { forEach } from 'lodash';
import { nodeListToArray } from '../../../Static/javascript/helpers/nodeListToArray'
import { Gallery } from '../../../Static/javascript/modules/gallery';
import { sendAddToCartScriptToGTM, sendCloudRetailAddToCartScriptToGTM } from '../../../Static/javascript/modules/shop-google-analytics';
import { togglePopupCartNav } from '../../../Static/javascript/modules/utility-nav';

(function () {
    // Request SVG sprite

    const productDetailClass = 'product-detail-feature';
    const productDetailFeature = nodeListToArray(document.querySelectorAll('[data-product-detail-feature]'));
    if (productDetailFeature.length > 0) {
        productDetailFeature.forEach((productFeature, index) => {
            let productSwiper = productFeature.querySelector('[data-product-swiper]');
            productSwiper.classList.add(`${productDetailClass}-${index}`);


            new Gallery({
                containerClass: `${productDetailClass}-${index}`,
                slidesPerView: 1,
                autoHeight: true,
                pagination: {
                    el: '.pdp-feature-bullets',
                    type: 'bullets',
                    clickable: true,
                    clickableClass: 'product-pagination-clickable',
                }
            })
            let pdpFeaturePagination = productFeature.querySelector('[pdp-feature-pagination]');
            if (pdpFeaturePagination) {
                let featurePagination = nodeListToArray(productFeature.querySelector('[pdp-feature-pagination]').children);
                featurePagination.forEach((thumbnail, index) => {
                    thumbnail.addEventListener('click', (e) => {
                        productSwiper.swiper.slideTo(index);
                    })
                })
            }
        });
    }


})();

//Display quantity discount messaging based on the quantity the user enters in the quantity box.
var quantityInput = document.getElementById('amount') as HTMLInputElement;
if (quantityInput) {
    showHideQuantityDiscountMessages(quantityInput);
    quantityInput.addEventListener('input', 
        function (this) {
            showHideQuantityDiscountMessages(this);
    })
}

function showHideQuantityDiscountMessages(quantityInput: HTMLInputElement) {
    var currentQuantityString = quantityInput.value;
    var currentQuantity = parseInt(currentQuantityString);

    var discountMessages = document.querySelectorAll('[data-quantity-minimum]') as NodeListOf<HTMLDivElement>;
    if (discountMessages && discountMessages.length > 0) {
        discountMessages.forEach((discountMessage) => {
            var minimumString = discountMessage.getAttribute('data-quantity-minimum');
            var maximumString = discountMessage.getAttribute('data-quantity-maximum');
            var minimum = parseInt(minimumString);
            var maximum = parseInt(maximumString);

            //check the quantity discount range. if the current quantity is within the range, display the message.
            var shouldShow = currentQuantity >= minimum && currentQuantity <= maximum;
            var displayStyle = shouldShow ? "block" : "none";
            discountMessage.style.display = displayStyle;
        })
    }
}


//Add to Cart
var addToCartCta = document.getElementById('addToCartCta') as HTMLButtonElement;
addToCartCta?.addEventListener('click',
    function (this) {
        addToCart(this);
    });

var miniSummaryAddToCartCta = document.getElementById('miniSummaryAddToCartCta') as HTMLButtonElement;
miniSummaryAddToCartCta?.addEventListener('click',
    function (this) {
        addToCart(this);
    });

const showErrorMessage = () => {
    var addToCartCta = document.querySelector('[data-add-cart-error]');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    addToCartCta.classList.remove('closed');
}
async function addToCart(element: HTMLButtonElement) {
    let code = (window as any).productDetailPageBootstrap.currentContentCode;
    let quantity = 1;
    const addToCartLoaders = document.querySelectorAll('[data-add-cart-load]');

    addToCartLoaders.forEach(el => {
        el.classList.add('loading');
    });
    if (quantityInput) {
        let quantityInputNumber = parseInt(quantityInput.value);
        if (quantityInputNumber && quantityInputNumber > 0) {
            quantity = quantityInputNumber;
        }
    }
    addItemToCart(code, quantity, addToCartLoaders, element);
}

var onlineCourseSeriesItemCtas = document.querySelectorAll('[data-series-item-id]') as NodeListOf<HTMLButtonElement>;
if (onlineCourseSeriesItemCtas && onlineCourseSeriesItemCtas.length > 0) {
    onlineCourseSeriesItemCtas.forEach((seriesItemCta) => {
        seriesItemCta?.addEventListener('click',
            function (this) {
                var itemId = seriesItemCta.getAttribute('data-series-item-id');

                const addToCartLoaders = seriesItemCta.querySelectorAll('[data-add-cart-load]');
                addToCartLoaders.forEach(el => {
                    el.classList.add('loading');
                });

                addItemToCart(itemId, 1, addToCartLoaders, this);
            });
    })
}

async function addItemToCart(itemId: string, quantity: number, addToCartLoaders: NodeListOf<Element>, addCtaButton: HTMLButtonElement) {
    let data = { Code: itemId, Quantity: quantity }
    var response = await fetch("/api/v1/cartservice/addtocart", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
        },
    });
    const jsonData = await response.json();
    if (response.ok) {
        if (response.status >= 200 && response.status < 300) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            togglePopupCartNav(jsonData.validationMessages);
            addToCartLoaders.forEach(el => {
                el.classList.remove('loading');
            });
            sendAddToCartScriptToGTM(addCtaButton);
            sendCloudRetailAddToCartScriptToGTM(addCtaButton);
        }
        else {
            showErrorMessage();
            addToCartLoaders.forEach(el => {
                el.classList.remove('loading');
            });
        }
    }
    else {
        addToCartLoaders.forEach(el => {
            el.classList.remove('loading');
        });
        showErrorMessage();
        addToCartLoaders.forEach(el => {
            el.classList.remove('loading');
        });
    }
}

